const COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY = "transcendConsentOverride";
const COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON = "true";
export {
  COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY,
  COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON
};
